export enum Statuses {
  SOON = 'soon',
  LIVE = 'live',
  ENDED = 'ended',
}
